<div class="h-100 w-100 flex place-content-center items-center">
    <div class="flex flex-col w-96 h-30 pb-20">
        <h1>Logging in</h1>
        <p>Logging you in please wait...</p>
        <!-- google -->
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

